<script context="module">
  export async function preload(page, session) {
    return {
      productSlug: page.params.productSlug,
    };
  }
</script>

<script>
  import { MetaTags } from 'svelte-meta-tags';

  export let productSlug;
</script>

<MetaTags
  title="Design Hub - Step 2. Choose Uniform Colours"
  titleTemplate="%s | Uniform Hero"
  description="Choose your colours. Select from our huge range of colour options for your custom shirts, shorts, socks, etc. Then step through our simple design process to create your perferct team uniform."
  canonical="https://uniformhero.com.au/design/tasman-sports-tshirt/choose-colours"
  openGraph={{
    url: `https://uniformhero.com.au/design/${productSlug}/choose-colours`,
    title: 'Uniform Hero | Design Hub Step 2 - Choose Uniform Colours',
    description: 'Order custom uniforms online in 5 easy steps. Fast delivery. Top quality products.',
    images: [
      {
        url: 'https://images.uniformhero.com.au/assets/opengraph-banner.jpg',
        width: 1200,
        height: 630,
        alt: 'Custom printed uniforms',
      },
    ],
    site_name: 'Uniform Hero',
    type: 'website',
  }}
/>
